import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    //buyNow弹窗、抽屉   upgradeNow按钮 是否禁用
    upgradeDisabled: true,
    //buyNow弹窗、抽屉   Other开关是否打开 默认关闭 固定只显示两条数据
    showOther: false,
    //产品列表
    spuList:[]
}

const mutations = {
    SET_UPGRADE_DISABLED(state, val) {
        state.upgradeDisabled = val;
    },
    SET_SHOW_OTHER(state,val){
        state.showOther = val;
    },
    SET_SPU_LIST(state,val){
        state.spuList = val;
    }
}
const getters = {
    upgradeDisabled(state) {
        return state.upgradeDisabled;
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    getters
};